import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal } from 'semantic-ui-react'
import { CerrarPopup } from '../Reducers/PopupReducer'

export const CtrlPopup = () => {
    const dispatch = useDispatch()
    const popup = useSelector(state => state.popup)
    const { Open, Titulo, Content, Height, TieneBotonCerrar } = popup;
    return (
        <Modal
            closeOnEscape={false}
            closeOnDimmerClick={false}
            open={Open}
        >
            <Modal.Header>{Titulo}</Modal.Header>
            <Modal.Content ><div className="popup-div-content">{Content}</div></Modal.Content>
            {
                TieneBotonCerrar && (<Modal.Actions>
                    <Button onClick={() => dispatch(CerrarPopup())} negative>Cerrar</Button>
                </Modal.Actions>)
            }
        </Modal>
    )
}
